module.exports = __webpack_public_path__ + "static/media/saveIcon.f0c07037.svg";